const scaleActions = {
  subscribeScaleUpdateAction: async ({ dispatch }, { slide }) => {
    dispatch('subscribeCountingForSlideAction', { slide, histogram: true })
    return function unsubscribeFn() {
      dispatch('unsubscribeScaleUpdateAction', { slide })
    }
  },

  unsubscribeScaleUpdateAction: async ({ dispatch }, { slide }) => {
    if (slide) {
      dispatch('unsubscribeCountingForSlideAction', { slide, histogram: true })
    }
  },
}

export default scaleActions
